module.exports = __webpack_public_path__ + "img/logo-rxsport.8a430c88.svg";